import React from "react";

const AllOnePlace = ({data}) => {
  return (
    <div className="">
      <h1
        className="text-4xl text-center lg:text-6xl
      font-popinsBold text-btnColor w-[90%] lg:w-[80%] mx-auto"
      >
        {data.heading}
      </h1>
      <div className="xl:bg-themeColor xl:h-[330px] xl:mt-[380px] relative">
        <div className=" flex flex-col md:flex-wrap md:flex-row justify-between w-[90%] 2xl:w-[85%] mx-auto xl:absolute top-[-330px] 2xl:top-[-300px] left-0 right-0">
          <div className="md:w-[49%] xl:w-[32%] xl:bg-white px-2 rounded-md shadow-xl mt-8 lg::mt-0">
            <img
              src='/assets/landlord/landlord1.png'
              alt=""
              className="w-full h-[180px] xl:h-[240px] object-fill"
            />
            <p className="text-themeColor font-popinsSemiBold text-xl pl-2 xl:pl-4 pt-6 xl:pt-10">
              {data.CardData[0].title}
            </p>
            <p className="font-popinsRegular text-[16px] pl-2 xl:pl-4 pb-6 pt-1 pr-2">
              {data.CardData[0].desc}
            </p>
          </div>
          <div className="md:w-[49%] xl:w-[32%] bg-white px-2 rounded-md shadow-xl mt-8 lg::mt-0">
            <img
              src={data.CardData[1].image}
              alt=""
              className="w-full h-[180px] xl:h-[240px] object-fill"
            />
            <p className="text-themeColor font-popinsSemiBold text-xl pl-2 xl:pl-4 pt-6 xl:pt-10">
             {data.CardData[1].title}
            </p>
            <p className="font-popinsRegular text-[16px] pl-2 xl:pl-4 pb-6 pt-1 pr-2">
             {data.CardData[1].desc}
            </p>
          </div>
          <div className="md:w-[49%] xl:w-[32%] bg-white px-2 rounded-md shadow-xl mt-8 lg::mt-0">
            <img
              src={data.CardData[2].image}
              alt=""
              className="w-full h-[180px] xl:h-[240px] object-fill"
            />
            <p className="text-themeColor font-popinsSemiBold text-xl pl-2 xl:pl-4 pt-6 xl:pt-10">
              {data.CardData[2].title}
            </p>
            <p className="font-popinsRegular text-[16px] pl-2 xl:pl-4 pb-6 pt-1 pr-2">
             {data.CardData[2].desc}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllOnePlace;
